import React from "react";
import { SessionProvider } from "./src/lib/api";
import "./src/styles/global.css";

export const wrapRootElement = ({ element }) => <SessionProvider>{element}</SessionProvider>;
